import React, { useState } from 'react';
import { Typography, Button, Modal as M, Box, Backdrop, Fade, useMediaQuery, useTheme } from '@mui/material';


function Modal({ open, onClose, Content, buttonClose = false, width = '30%', disablePortal = false }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  //const [open, setOpen] = useState(false);

  // const handleOpen = () => {
  //   setOpen(true);
  // };

  const handleClose = () => {
    if (onClose) {
      onClose()
    }
    //setOpen(false);
  };

  return (
    <div>
      {/* <Button variant="contained" onClick={handleOpen}>
          Abrir Modal
        </Button> */}
      <M
        open={open}
        //onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        //onBackdropClick={false}
        disablePortal={disablePortal}
        style={disablePortal ? { position: 'absolute' } : undefined}
        BackdropProps={disablePortal ? { style: { position: 'absolute' } } : undefined}
      >
        <Box sx={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: isMobile ? '90%' : width,
          bgcolor: 'background.paper',
          boxShadow: 24,
          maxHeight: '80vh',
          overflowY: 'auto',
          background: '#f2e8e4',
          justifyItems: 'center',
          alignItems: 'center'
        }}
        >
          <Typography variant="h6" component="h2" sx={{ margin: 1 }} justifySelf='stretch'>
            <Content />
          </Typography>
          {buttonClose && <Button variant="outlined" onClick={handleClose}>
            Aceptar
          </Button>}
        </Box>
      </M>
    </div>
  );
}

export default Modal;